// @ts-nocheck
import { Form, Input, Typography, Modal } from 'antd';
import React from 'react';
import classes from './SupportModal.module.scss';
import { useTranslation } from 'react-i18next';
import TextArea from 'antd/es/input/TextArea';
import { useAppSelector } from 'store/hook';
import UploadingComponent from 'components/UploadingComponent/UploadingComponent';
import auth from 'api/auth';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';

type SupportModalProps = {
  isSupportModalOpen?: boolean;
  onCancel: () => void;
};

const SupportModal = ({
  isSupportModalOpen,
  onCancel,
}: SupportModalProps) => {
  // const [fileList, setFileList] = React.useState<UploadFile[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const { userData } = useAppSelector(store => store.userData);
  const { messageApi } = useAppSelector(store => store.windowState);

  const [form] = Form.useForm();
  const { t } = useTranslation();

  React.useEffect(() => {
    form.setFieldsValue({ email: userData?.email});
  }, [userData])

  const onFinish = async (values: any) => {
    setIsLoading(true);
    try {
      // const formData = new FormData();
      // formData.append('email', values.email);
      // formData.append('text', values.text);
      // fileList[0] && formData.append('file', fileList[0] as RcFile);

      await auth.sendMessageToSupport(values);
      messageApi?.success(t('Header.supportModal.successSend'), 10);
      onCancel()
    } catch (err) {
      messageApi?.error(t('Header.supportModal.errorSend'), 10);
    } finally {
      setIsLoading(false);
    }
  };

  // const uploadProps: UploadProps = {
  //   onRemove: (file) => {
  //     const index = fileList.indexOf(file);
  //     const newFileList = fileList.slice();
  //     newFileList.splice(index, 1);
  //     setFileList(newFileList);
  //   },
  //   beforeUpload: (file) => {
  //     setFileList([...fileList, file]);

  //     return false;
  //   },
  //   fileList,
  // };

  return (
    <Modal
      className={cn(classes.modal, getTheme())}
      width={'60%'}
      onCancel={() => onCancel()}
      title={t('Header.supportModal.title')}
      open={isSupportModalOpen}
      centered={true}
      onOk={form.submit}
      okButtonProps={{loading: isLoading}}
      okText={t('Header.supportModal.okText')}
      styles={{
        body: { padding: '20px 20px 10px 20px' },
      }}
    >
      <Form form={form} onFinish={onFinish} layout='vertical'>
        <Form.Item
          name='email'
          label={t('Header.supportModal.emailLabel')}
          rules={[
            { whitespace: true },
            { required: true },
            { type: 'email' }
          ]}
        >
          <Input
            disabled={Boolean(userData?.email) || isLoading}
            placeholder={t('Header.supportModal.emailPlaceholder')}
          />
        </Form.Item>
        <Form.Item
          name='text'
          label={t('Header.supportModal.textLabel')}
          rules={[{ required: true }]}
        >
          <TextArea
            disabled={isLoading}
            autoSize={{minRows: 6, maxRows: 12}}
            className={classes.textarea}
            placeholder={t('Header.supportModal.textPlaceholder')}
          />
        </Form.Item>

        {/* <Form.Item
          name='file'
          label={'Прикрепить файл'}
        >
          <Upload {...uploadProps}>
            {!fileList[0] && <Button icon={<UploadOutlined />}>Select File</Button>}
          </Upload>
        </Form.Item> */}
      </Form>
      {/* {window.REACT_APP_SUPPORT_NUMBER !== 'REPLACE_REACT_APP_SUPPORT_NUMBER' && (
        <Typography>
          <strong>{`${t('Header.supportModal.whatsapp')}: `}</strong>
          <a className={classes.link} target="_blank" href={`https://wa.me/${window.REACT_APP_SUPPORT_NUMBER}`} rel="noreferrer">{`+${window.REACT_APP_SUPPORT_NUMBER}`}</a>
        </Typography>
      )} */}
      {window.REACT_APP_ORG_INFO !== 'REPLACE_REACT_APP_ORG_INFO' && <Typography>{window.REACT_APP_ORG_INFO}</Typography>}

      {isLoading && <UploadingComponent />}
    </Modal>
  );
}

export default SupportModal;
